<i18n>
{
  "cl": {
    "select": "Seleccione",
    "00-03": "Menos de 3 meses",
    "03-06": "De 3 a 6 meses",
    "06-12": "De 6 meses a 1 año",
    "12OrMore": "Más de 1 año",
    "notDefined": "No esta definido",
    "purchaseDate": "Fecha estimada de compra"
  }
}
</i18n>
<template>
  <div id="simulation-details" data-cy="component-simulation">
    <div class="columns">
      <div class="column is-6">
        <SimulationCard :read-only="readOnlySimulation" />
      </div>
      <div class="column is-6">
        <PropertyCard is-open :read-only="readOnlySimulation" />
      </div>
    </div>
  </div>
</template>

<script>
import SimulationCard from '@/ui/components/internal/evaluations/verify/SimulationCard.vue';
import PropertyCard from '@/ui/components/internal/evaluations/verify/PropertyCard.vue';
import { getSafe } from '@/application/services/get-safe';

export default {
  name: 'Simulation',
  components: { PropertyCard, SimulationCard },
  data() {
    return {
      readOnlySimulation: !getSafe(this.$store, 'state.currentUser.user.allowedUserFeatures', []).includes('element.evaluation.simulation.edit')
    };
  }
};
</script>

<style scoped>
</style>
<style>
@media screen and (min-width: 992px) {
  #simulation-details .is-horizontal .field-label {
    flex-grow: 3;
  }
}
</style>
